import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from 'hooks/ui';

import { useApplicationStore } from 'store/application';
import { BroadcastTags_queryKey } from './constants';
import { deleteBroadcastTag } from '../../../api/appSettings.service';

export const useDeleteBroadcastTagQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { setLoading, removeLoading } = useApplicationStore();

  const { isPending, isError, mutate } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return deleteBroadcastTag(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BroadcastTags_queryKey] });
      toast.success('Broadcast tag has been deleted successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => removeLoading(),
  });

  return { isLoading: isPending, isError, mutate };
};
